var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"logo-container pt-2",attrs:{"fluid":""}},[_c('div',{staticClass:"container pt-4 d-flex justify-content-center flex-wrap"},_vm._l((_vm.imgArr),function(img,i){return _c('div',{key:i,staticClass:"logos mb-2 transition-effect"},[_c('img',{attrs:{"src":img.src,"height":"30","fluid":""}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ffc836c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Logos.vue
// module id = 180
// module chunks = 0